import { isChunkLoadError, reloadOnceOnChunkError } from '~/lib/chunkLoadError'

function tryReloadFromError (error: unknown) {
  if (isChunkLoadError(error)) {
    reloadOnceOnChunkError()
  }
}

// After a deploy, open POS tabs still point at old hashed /_nuxt/*.js files.
// Vite/Nuxt then fail the dynamic import and the merchant is stuck on a blank
// or half-rendered page. Reload once so the new index.html can pick up the
// current chunk map. A 15s cooldown prevents a loop if the user is offline.
export default defineNuxtPlugin((nuxtApp) => {
  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault()
    reloadOnceOnChunkError()
  })

  window.addEventListener('unhandledrejection', (event) => {
    if (isChunkLoadError(event.reason)) {
      event.preventDefault()
      reloadOnceOnChunkError()
    }
  })

  nuxtApp.hook('app:error', tryReloadFromError)
  nuxtApp.hook('vue:error', tryReloadFromError)
})
